module.exports = __webpack_public_path__ + "static/assets/a11c1802ec38e7fe60918fb52186261f.svg";